
<div class="commission-general" >

    <div class="timer">
        <div>
            <span>
                {{'REQUEST.COMMISSION.CALCULATIONS' | translate}}
            </span>

            <span>
                <tc-countdown *ngIf="!commissionIsExpired && commissionResult && commissionResult.success && interval" [leftTime]="interval"
                    (finishedEmit)="onTimerFinished()">
                </tc-countdown>
               
            </span>
        </div>
    </div>

    <div class="img" *ngIf="(!commissionResult || !commissionResult.success) && !calculateLoading">
        <!-- <i class="icon-request-hand"></i> -->
        <img src="./assets/media/images/commission/icon-commission.png">
    </div>

    <tc-table-loading *ngIf="calculateLoading"></tc-table-loading>

    <tc-commission-exchange-first [getAmountTitle]="getAmountTitle" [payAmountTitle]="payAmountTitle" *ngIf="showCommissionFirst" [commission]="commissionResult" [calculateLoading]="calculateLoading"></tc-commission-exchange-first>
    <tc-commission-exchange-last [getAmountTitle]="getAmountTitle" [payAmountTitle]="payAmountTitle" *ngIf="showCommissionLast" [requestType]="requestType" [commission]="commissionResult" [calculateLoading]="calculateLoading"></tc-commission-exchange-last>
</div>
